import React from "react";
// Component Library
import Button from "@acadia-ui/button";
import Modal, { MODAL_TYPE } from "@acadia-ui/modal";

import "./ErrorMessagesModal.scss";

const ErrorMessagesModal = ({ modalId, description = "", errors }) => {
	return (
		<Modal
			id={modalId}
			className="error-messages-modal"
			heading="Error"
			description={description}
			type={MODAL_TYPE.WARNING}
			onClick={() => {}}
			actionSetProps={{
				actionsRight: (
					<Button onClick={() => Modal.hide(modalId)} data-tracking-id-alt="close-error-messages-modal">
						Done
					</Button>
				)
			}}
		>
			<div className="additional-errors-container">
				{errors.map((error) => {
					return <div className="additional-error">{error}</div>;
				})}
			</div>
		</Modal>
	);
};
export default ErrorMessagesModal;
